import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';

import { EffectType, ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import { getEffectComponent } from '@/components/DesignStudio/ImageEffectsProperties/utils/componentMapper';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesListItemEdit',
  props: {
    item: null,
    isOpen: { type: Boolean }
  },
  emits: ["update", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update', value: ImageEffectType): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    item: ImageEffectType;
    isOpen: boolean;
};





const formData = ref<ImageEffectType | undefined>(undefined);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const currentEffectComponent = ref<any>(null);

const loadEffectComponent = async (effectType: EffectType) => {
    try {
        currentEffectComponent.value = await getEffectComponent(effectType);
    } catch (error) {
        console.error('Error loading effect component:', error);
        currentEffectComponent.value = null;
    }
};

const resetForm = () => {
    currentEffectComponent.value = null;
};

const handleClose = () => {
    resetForm();
    emit('close');
};

const handleSave = () => {
    if (!formData.value) return;
    emit('update', formData.value);
    handleClose();
};

watch(
    () => props.isOpen,
    () => {
        if (props.isOpen) {
            if (props.item) {
                formData.value = { ...props.item };
                loadEffectComponent(props.item.type);
            }
        }
    }
);

return { __sfc: true,props, emit, formData, currentEffectComponent, loadEffectComponent, resetForm, handleClose, handleSave, CModal, CButton }
}

})